import { io } from 'socket.io-client';

import loginService from '../login.service';

const TEARDOWN_GRACE_MS = 5000;
const SERVER_RESTART_RECONNECT_MS = 2000;
const SERVER_DISCONNECT_REASON = 'io server disconnect';

let socket = null;
let subscriberCount = 0;
let teardownTimeout = null;

const socketUrl = () => process.env.REACT_APP_API_URL || 'https://api.facilitajuridico.com';

// A api só derruba a conexão quando desliga, no deploy. Nesse caso o client do socket.io
// não reconecta sozinho, e o vendedor ficaria sem tempo real nem sinal de trabalho até
// recarregar a página. A espera dá tempo de a instância nova assumir.
const reconnectAfterServerRestart = (disconnectedSocket) => (reason) => {

    if (reason !== SERVER_DISCONNECT_REASON)
        return;

    setTimeout(() => {
        if (socket === disconnectedSocket)
            disconnectedSocket.connect();
    }, SERVER_RESTART_RECONNECT_MS);
}

const connect = () => {

    if (socket)
        return socket;

    socket = io(socketUrl(), {
        transports: ['websocket', 'polling'],
        auth: (callback) => callback({ token: loginService.getToken() }),
    });
    socket.on('disconnect', reconnectAfterServerRestart(socket));

    return socket;
}

const teardown = () => {
    teardownTimeout = null;

    if (subscriberCount > 0 || !socket)
        return;

    socket.disconnect();
    socket = null;
}

const scheduleTeardown = () => {
    if (teardownTimeout)
        clearTimeout(teardownTimeout);

    teardownTimeout = setTimeout(teardown, TEARDOWN_GRACE_MS);
}

const cancelTeardown = () => {
    if (!teardownTimeout)
        return;

    clearTimeout(teardownTimeout);
    teardownTimeout = null;
}

const subscribe = (event, handler) => {

    cancelTeardown();
    subscriberCount += 1;

    const currentSocket = connect();
    currentSocket.on(event, handler);

    let unsubscribed = false;

    return () => {
        if (unsubscribed)
            return;

        unsubscribed = true;
        subscriberCount -= 1;
        currentSocket.off(event, handler);

        if (subscriberCount <= 0)
            scheduleTeardown();
    };
}

// O client do socket.io guarda o que é emitido desconectado e manda tudo de uma vez ao
// reconectar; por isso só emite com a conexão de pé e nunca abre uma para emitir.
const emit = (event, payload) => {

    if (!socket?.connected)
        return false;

    socket.emit(event, payload);
    return true;
}

export default {
    subscribe,
    emit,
}
